import React from 'react';
import { TextVariant } from '@naf/text';
import { Tag } from '@naf-simba/elements-tag';
import { getLabelVariant } from '@lib/getLabelVariant';
import { Heading, Description, HeadingBlock, TagWrapper } from '../Styles';
import { ButtonGroup } from '../StyledFeaturedBenefitBlock';
import { FeaturedBenefitBlockTypeProps } from '../FeaturedBenefitBlock/FeaturedBenefitBlock';
import * as S from './VerticalWithList.styles';
import { Step } from './Step/Step';

export const VerticalWithList: React.FC<FeaturedBenefitBlockTypeProps> = ({ block }) => {
  const { title, description, steps, primaryCta, secondaryCta, colorVariant, tag } = block;
  const tagVariant = getLabelVariant(colorVariant);

  return (
    <S.StyledWrapper $variant={colorVariant}>
      <S.StyledContent>
        <S.Left>
          {tag && (
            <TagWrapper>
              <Tag text={tag} color={tagVariant.color} />
            </TagWrapper>
          )}
          <Heading variant={TextVariant.Display}>
            <HeadingBlock value={title} />
          </Heading>
          {description && <Description>{description}</Description>}
          <S.ButtonGroupMargin />
          <ButtonGroup primaryCta={primaryCta} secondaryCta={secondaryCta} colorVariant={colorVariant} />
        </S.Left>
        <S.Right>
          <S.Column>
            {steps?.map((step) => (
              <Step key={step.title} step={step} />
            ))}
          </S.Column>
        </S.Right>
      </S.StyledContent>
    </S.StyledWrapper>
  );
};
